import { FC, useCallback, useEffect, useRef } from 'react';
import noUiSlider, { API, PipsMode } from 'nouislider';
import { clx } from 'Utils';
import { useLocation, useNavigate } from 'react-router-dom'; // Replace Next.js hooks
import { SearchFilterGroup } from 'Elements';
import 'nouislider/dist/nouislider.css';
import styles from 'partials/job/filters/job-filters-distance-range.module.scss';

interface Props {
	className?: string;
	setPageNumber?: any;
}

interface TargetElement extends HTMLDivElement {
	noUiSlider?: API;
}

export const JobFilterDistanceRange: FC<Props> = ({
	className,
	setPageNumber
}) => {
	const location = useLocation();
	const navigate = useNavigate();
	const rangeEl = useRef<TargetElement>(null);
	const defaultDistance = 25;

	const query = new URLSearchParams(location.search);

	const setSearchParams = (params: Record<string, string>) => {
		const updatedQuery = new URLSearchParams(location.search);
		Object.keys(params).forEach((key) => {
			updatedQuery.set(key, params[key]);
		});
		navigate({ search: updatedQuery.toString() }, { replace: true });
	};

	const handleChangeDistance = useCallback(
		(value: (string | number)[]) => {
			const stepValue = +value.join();
			setSearchParams({
				distance: stepValue.toString(),
				page: '1'
			});
			setPageNumber && setPageNumber(1);
		},
		[setSearchParams, setPageNumber]
	);

	const initRangeSlider = useCallback(() => {
		const rangeRef = rangeEl.current;
		if (rangeRef) {
			noUiSlider.create(rangeRef, {
				start: query.get('distance') || defaultDistance,
				margin: 0,
				connect: [true, false],
				range: {
					min: 10,
					max: 100
				},
				step: 15,
				pips: {
					mode: PipsMode.Steps,
					density: 15
				}
			});
			rangeRef?.noUiSlider?.on('change', handleChangeDistance);
		}
	}, [handleChangeDistance, query]);

	useEffect(() => {
		const rangeRef = rangeEl.current;
		if (rangeRef) initRangeSlider();

		return () => {
			if (rangeRef) rangeRef?.noUiSlider?.destroy();
		};
	}, [initRangeSlider]);

	return (
		<SearchFilterGroup
			title="title.distance"
			className={clx(className)}
			contentClassName={styles.container}>
			<div ref={rangeEl} className={styles.slider_styled}></div>
		</SearchFilterGroup>
	);
};
